import type { MessageDescriptor } from "react-intl";

// The three curated-resource kinds. The union doubles as a discriminator (Watch
// feed filtering, tile styling) and as a user-facing badge on two surfaces, so
// the label lives here instead of being re-typed at each call site as a literal
// (ADR-0013: no hardcoded user-facing strings).

export type MediaKind = "Video" | "Podcast" | "Script";

export const MEDIA_KINDS: readonly MediaKind[] = ["Video", "Podcast", "Script"];

export const MEDIA_KIND_LABEL: Record<MediaKind, MessageDescriptor> = {
  Video: { id: "grow.mediaKind.video", defaultMessage: "Video" },
  Podcast: { id: "grow.mediaKind.podcast", defaultMessage: "Podcast" },
  Script: { id: "grow.mediaKind.script", defaultMessage: "Script" },
};
